module.exports = __webpack_public_path__ + "static/2-8605a6eada224d15b3b31ba6d0080a1b.png";